import { render, staticRenderFns } from "./YourTeamNotificationComponent.vue?vue&type=template&id=4b8970a6&"
import script from "./YourTeamNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./YourTeamNotificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports